import { siteModel } from 'models/SiteModel';
import { repository } from 'repositories/matchCalendarRepository';
import moment from 'moment/moment';

export default class MatchBarRepository
{
    constructor(shared) {
        this.loads = {
            list: null,
            day: null,
        };
        this.match = null;
        this.list = [];
        this.collection = {
            past: [],
            live: null,
            upcoming: [],
        };
        this.shared = shared;
    }

    onMatchListLoad() {
        const request = (resolve) => {
            window.addEventListener('MatchCalendarLoadExecuted', (evt) => {
                this.loads.list = evt.detail;
                return resolve(evt.detail);
            }, false);
        };
        return new Promise(request);
    }

    onMatchDayLoad() {
        const request = (resolve) => {
            window.addEventListener('MatchCalendarDayLoadExecuted', (evt) => {
                this.loads.day = evt.detail;
                return resolve(evt.detail);
            }, false);
        };
        return new Promise(request);
    }

    onInitialize() {
        const request = (resolve, reject) => {
            if (this.shared) {
                const all = Promise.all([this.onMatchListLoad(), this.onMatchDayLoad()]);
                all.then(([list, day]) => {
                    if (day.date === list.currentMatchbarDay) {
                        return resolve([list, day.data]);
                    } else {
                        return this.requestMatchDay(list.currentMatchbarDay).then((response) => {
                            return resolve([list, response]);
                        }).catch((error) => {
                            return reject(error);
                        });
                    }
                }).catch((error) => {
                    return reject(error);
                });
            } else {
                const all = Promise.all([this.requestAllDays()]);
                all.then(([list]) => {
                    return this.requestMatchDay(list.currentMatchbarDay).then((response) => {
                        return resolve([list, response]);
                    }).catch((error) => {
                        return reject(error);
                    });
                }).catch((error) => {
                    return reject(error);
                });
            }
        };
        return new Promise(request).then(([list, day]) => {
            this.match = this.getCurrentMatch(day);
            this.list = this.filterList(list);
            this.collection = this.getCollection(this.list, this.match);
            this.collection = this.fillInCollection(this.collection);

            return this.collection;
        });
    }

    requestMatch(day) {
        return this.requestMatchDay(day).then((response) => {
            this.collection.live = this.getCurrentMatch(response);
            return this.collection.live;
        });
    }

    requestAllDays() {
        return repository.load();
    }

    requestMatchDay(day) {
        return repository.loadDay(day);
    }

    filterList(list) {
        const result = list.calendar;
        return result.filter((o) => {
            return (o.firstTeamMatches > 0);
        });
    }

    getCurrentMatch(day) {
        const match = (day.matches || {})[0];
        return (match !== void 0) ? match : null;
    }

    getCollection(list, match) {
        const collection = {
            past: [],
            live: match,
            upcoming: [],
        };
        const matchDate = moment(match.matchDate, 'DD.MM.YYYY');
        let status = 'past';

        for (const obj of list) {
            if (moment(obj.day).isSame(matchDate.format('YYYY-MM-DD'))) {
                status = 'upcoming';
            } else {
                collection[status].push(obj);
            }
        }

        return collection;
    }

    fillInCollection(collection) {
        const properties = ['past', 'upcoming'];
        const minimum = 2;

        properties.map((v) => {
            const len = collection[v].length;
            if (len < minimum) {
                for (let i = 0; i < (minimum - len); i++) {
                    collection[v].push(false);
                }
            }
        });
        return collection;
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/repositories/matchBarRepository.js